import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Wrapper } from 'modules/theme';
import { ControlLabels } from './form/styles';
import {
  Box,
  RowTitle,
  BoxName,
  Row,
} from '../styles/main';

import { globalStateSelector } from 'store/selector';
import { connect } from 'react-redux';
import { superAdminAccess, userAccess } from '../../../../../helpers/system-config';

class SettingTheme extends Component {
  renderBox(name, image, to, block) {
    const { __ } = this.context;
    return (
      <Box>
        <Link
          style={!block ? {} : { cursor: 'not-allowed' }}
          to={!block ? to : '#'}
        >
          <img src={image} alt={name} />
          <BoxName>{__(name)}</BoxName>
        </Link>
      </Box>
    );
  }

  render() {
    const { __ } = this.context;
    const breadcrumb = [{ title: __('Settings'), link: '/settings' }];
    let { currentUser } = this.props;
    // console.log(`currentUser`, currentUser);
    // currentUser = currentUser || {};
    // let agentRole = currentUser.role || '';
    // // const userAccess = [Role.SUPER_ADMIN, Role.ADMIN]
    // console.log('userAccess',userAccess);
    // console.log('Current Userssss', agentRole);

    const content = (
      <div>
        <Row style={{ marginLeft: '20px' }}>
          <RowTitle className="secondRow">
            {__('Users and Permissions')}
          </RowTitle>
        </Row>
        <Row style={{ marginLeft: '20px' }}>
          <div>
            <div>
              {this.renderBox(
                __('Members'),
                '/images/User-t.png',
                '/settings/User'
              )}
              {this.renderBox(
                __('Skills'),
                '/images/Skill-t.png',
                '/settings/Skills',
                true
              )}
              {userAccess.includes(currentUser.role) && this.renderBox(
                __('Permissions'),
                '/images/Permission-t.png',
                '/settings/Break',
                true
              )}
              {/* {this.renderBox(
                __('User Map Skill'),
                '/images/Skill-t.png',
                '/settings/usermapskill',
              )} */}
              {/* {currentUser.role >= 1 && currentUser.role <= 2 && this.renderBox(
                __('Permissions'),
                '/images/ACCESS-POINT.svg',
                '/settings/Break',
                true
              )} */}
              {/* {this.renderBox(
                __('Permissions'),
                '/images/ACCESS-POINT.svg',
                '/settings/Break',
                true
              )} */}
            </div>
          </div>
        </Row>
        <Row>
          <hr style={{ width: '95%' }} />
        </Row>
        <Row style={{ marginLeft: '25px' }}>
          <RowTitle className="secondRow">
            {__('Communication Channels')}
          </RowTitle>
        </Row>
        <Row style={{ marginLeft: '25px' }}>
          <div>
            <div>
              {this.renderBox(
                __('Providers'),
                '/images/Provider-t.png',
                '/settings/providers'
              )}
              {userAccess.includes(currentUser.role) && this.renderBox(
                __('Phone Number'),
                '/images/Phonenumber-t.png',
                '/settings/Phonenumbers'
              )}
              {/* {this.renderBox(
                __('Phone Number'),
                '/images/PHONE-NUMBER.svg',
                '/settings/Phonenumbers'
              )} */}
              {userAccess.includes(currentUser.role) && this.renderBox(
                __('SIP Extension'),
                '/images/Sip-t.png',
                '/settings/SIPExtensions'
              )}

              {this.renderBox(
                __('Integration'),
                '/images/Integration-t.png',
                '/settings/integrations',
                false
              )}
            </div>
          </div>
        </Row>
        <Row>
          <hr style={{ width: '95%' }} />
        </Row>
        <Row style={{ marginLeft: '25px' }}>
          <RowTitle className="secondRow">{__('General Settings')}</RowTitle>
        </Row>
        <Row style={{ marginLeft: '25px' }}>
          <div>
            <div>
              {this.renderBox(__('Tags'), '/images/Tag-t.png', '/settings/despose')}
              {this.renderBox(
                __('Contact'),
                '/images/Contact-t.png',
                // '/settings/ContactListPrivate'
                '/settings/ContactList'
              )}
              {/* {this.renderBox(
                __('Queue'),
                '/images/Queue-t.png',
                '/settings/Queue'
              )} */}
              {this.renderBox(
                __('Sounds'),
                '/images/Sound-t.png',
                '/settings/sounds'
              )}
              {this.renderBox(
                __('Break'),
                '/images/Break-t.png',
                '/settings/Break'
              )}
              {this.renderBox(__('DNC'), '/images/Dnc-t.png', '/settings/DNC')}
              {this.renderBox(
                __('Holiday'),
                '/images/Holiday-t.png',
                '/settings/Holiday',
                true
              )}

            </div>
            <div>


              {this.renderBox(__('CSAT'), '/images/Csat.t.png', '/settings/CSAT',true)}
              {this.renderBox(
                __('Country'),
                '/images/Country.t.png',
                '/settings/Country'
              )}
              {this.renderBox(
                __('Flow'),
                '/images/FLow-t.png',
                '/settings/flow'
              )}
              {this.renderBox(
                __('Sticky Group'),
                '/images/Import-t.png',
                '/settings/sticky-group'
              )}
              {this.renderBox(
                __('Import & Export'),
                '/images/Import-t.png',
                '/settings/import-export'
              )}
              {this.renderBox(
                __('Logs'),
                '/images/logs.png',
                '/settings/logs'
              )}
            </div>
          </div>
        </Row>
        {userAccess.includes(currentUser.role) &&
          <span>
            <Row>
              <hr style={{ width: '95%' }} />
            </Row>
            <Row style={{ marginLeft: '25px' }}>
              <RowTitle className="secondRow">{__('Account Settings')}</RowTitle>
            </Row>
            <Row style={{ marginLeft: '25px' }}>
              <div>
                {this.renderBox(
                  __('Account'),
                  '/images/Account-t.png.png',
                  '/settings/account',
                  true
                )}
                {this.renderBox(
                  __('Plans and Billing'),
                  '/images/Plan-t.png',
                  '/settings/Country',
                  true
                )}
              </div>
            </Row>
          </span>
        }
        {superAdminAccess.includes(currentUser.role) &&
          <Row style={{ marginLeft: '25px' }}>
            <div>
              {this.renderBox(
                __('Region'),
                '/images/Account-t.png.png',
                '/settings/region'
              )}
            </div>
          </Row>}

      </div>
    );

    return (
      <Wrapper
        header={<Wrapper.Header breadcrumb={breadcrumb} />}
        actionBar={
          <Wrapper.ActionBar
            left={
              <div>
                <ControlLabels>Admin Setting</ControlLabels>
              </div>
            }
          // right={actionBarRight}
          // right={this.renderActionBar()}
          />
        }
        content={content}
        transparent={false}
      />
    );
  }
}

SettingTheme.contextTypes = {
  __: PropTypes.func
};

const stateToProps = state => ({
  currentUser: globalStateSelector.getDynamic(state, { key: 'currentUser' })
});

const dispatchToProps = dispatch => ({
  dynamicUpdate: data => {
    // dispatch(globalAction.dynamicUpdate({ data }));
  }
});

export default connect(stateToProps, dispatchToProps)(SettingTheme);



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/SettingTheme.js